<template>
<div class="modal-video-player-content">

	<video-embed 
		:type="media.type" 
		:video_slug="media.video_slug"
		:sound="true"
		:controls="true"
		:blockmode="true"
	/>

	<iframe v-if=" false && media.type == 'vimeo' "
		:id="media.id"
		:src="'https://player.vimeo.com/video/'+ media.video_slug +'?autoplay=1&loop=1&title=0&portrait=0&byline=0&title=0&autopause=0&background=1&quality=720p'" 
		frameborder="0" 
		allow="autoplay; fullscreen" 
		allowfullscreen
	></iframe>
	
	<iframe v-if=" false && media.type == 'youtube' "
		:id="media.id"
		type="text/html" 
		width="100%" 
		height="100%"
		:src="'https://www.youtube.com/embed/'+ media.video_slug +'?autoplay=1&controls=0&loop=1&playlist='+ media.video_slug +'&modestbranding=1&version=3&rel=0&showinfo=0&origin=https://scoopmodels.com'"
		allow="autoplay; fullscreen" 
		allowfullscreen
		autoplay
		frameborder="0"
	></iframe>

</div>
</template>
<script>
import mixins from '.././mixins.js'
import axios from 'axios'; import qs from 'qs'
import VideoEmbed from '.././components/VideoEmbed.vue'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 				
		VideoEmbed, 
	},

	data(){ return {
		
		
	}},

	computed: {

		media(){
			return this.$store.state.modal.video_player.media
		},

	},

	methods: {

		

	},

	created(){

		//this.$store.dispatch('load_admin_generic_items', { fetch:'artists' })			

	},

}
</script>



// WEBPACK FOOTER //
// src/views/VideoPlayer.vue